/* =========================================================
   Premium Enhancements — Capa Premium para Shopify
   premium-enhancements.js
   ---------------------------------------------------------
   Vanilla JS, sin dependencias. Se auto-inicializa.
   Cárgalo con `defer` para que no bloquee el render.
   Respeta prefers-reduced-motion en todas las animaciones.
   ========================================================= */
(function () {
  "use strict";

  /* =========================================================
     CONFIG — ajústala a tu gusto
     ========================================================= */
  var CONFIG = {
    // Revela automáticamente las secciones del tema al hacer scroll.
    // Ponlo en false para controlar tú cada sección a mano
    // (con data-pe-reveal="…") o marcar excepciones con data-pe-no-reveal.
    autoRevealSections: true,

    // Barra de progreso de scroll fija arriba de la página.
    enableProgressBar: false,

    // Tipo de animación para el auto-reveal de secciones:
    // "fade" | "left" | "right" | "zoom"
    sectionRevealType: "fade",

    // % del elemento visible para disparar el reveal (0–1).
    revealThreshold: 0.12,

    // Margen del viewport para adelantar/atrasar el disparo.
    revealRootMargin: "0px 0px -8% 0px",

    // Duración de la animación de los contadores (ms).
    counterDuration: 1600
  };

  /* =========================================================
     Estado / utilidades
     ========================================================= */
  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  /* =========================================================
     1. REVEAL AL HACER SCROLL
     ========================================================= */
  function setupReveals() {
    // Auto-marcar secciones del tema si está activado.
    if (CONFIG.autoRevealSections) {
      var sections = document.querySelectorAll(".shopify-section");
      Array.prototype.forEach.call(sections, function (sec) {
        var yaMarcada = sec.hasAttribute("data-pe-reveal");
        var tieneRevealDentro = sec.querySelector("[data-pe-reveal]");
        var excluida = sec.hasAttribute("data-pe-no-reveal") ||
                       sec.closest("[data-pe-no-reveal]");
        if (!yaMarcada && !tieneRevealDentro && !excluida) {
          sec.setAttribute("data-pe-reveal", CONFIG.sectionRevealType);
        }
      });
    }

    var targets = document.querySelectorAll("[data-pe-reveal]");
    if (!targets.length) return;

    // Sin IntersectionObserver o con reduced-motion: mostrar todo ya.
    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      Array.prototype.forEach.call(targets, function (el) {
        el.classList.add("pe-in");
      });
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("pe-in");
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: CONFIG.revealThreshold,
      rootMargin: CONFIG.revealRootMargin
    });

    Array.prototype.forEach.call(targets, function (el) { io.observe(el); });
  }

  /* =========================================================
     2. CONTADORES ANIMADOS
     <span data-pe-counter="1250" data-suffix="+"
           data-prefix="" data-decimals="0">0</span>
     ========================================================= */
  function animateCounter(el) {
    var end = parseFloat(el.getAttribute("data-pe-counter")) || 0;
    var decimals = parseInt(el.getAttribute("data-decimals"), 10);
    if (isNaN(decimals)) decimals = 0;
    var prefix = el.getAttribute("data-prefix") || "";
    var suffix = el.getAttribute("data-suffix") || "";
    var dur = CONFIG.counterDuration;

    function format(v) {
      return prefix + Number(v).toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }) + suffix;
    }

    if (prefersReducedMotion) {
      el.textContent = format(end);
      return;
    }

    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      el.textContent = format(end * eased);
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = format(end);
      }
    }
    requestAnimationFrame(step);
  }

  function setupCounters() {
    var counters = document.querySelectorAll("[data-pe-counter]");
    if (!counters.length) return;

    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      Array.prototype.forEach.call(counters, animateCounter);
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.6 });

    Array.prototype.forEach.call(counters, function (el) { io.observe(el); });
  }

  /* =========================================================
     3. BARRA DE PROGRESO DE SCROLL
     ========================================================= */
  function setupProgressBar() {
    if (!CONFIG.enableProgressBar || prefersReducedMotion) return;

    var bar = document.createElement("div");
    bar.className = "pe-progress-bar";
    document.body.appendChild(bar);

    var ticking = false;
    function update() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var top = h.scrollTop || window.pageYOffset || 0;
      var pct = max > 0 ? (top / max) * 100 : 0;
      bar.style.width = pct + "%";
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
  }

  /* =========================================================
     INIT
     ========================================================= */
  onReady(function () {
    setupReveals();
    setupCounters();
    setupProgressBar();
  });
})();